import FontBody1 from "../../../../components/fonts/font-body1/font-body1";
import { FONT_COLOR, FONT_VARIANT } from "../../../../components/fonts/font-props";
import { ButtonLink } from "../../../../components/inputs/button-link/button-link";
import { BUTTON_VARIANTS } from "../../../../components/inputs/button-variants";
import { Button } from "../../../../components/inputs/button/button";
import useDashboardTranslation from "../../../../dashboard-translation/hooks/dashboard-translation-hook";
import onboardingNavigationStore from "../../stores/onboarding-navigation-store";
import "./return-guard-navigation-controls.scss";

interface IReturnGuardNavigationControlsType {
    onBackClick?: () => void;
    onSetupLaterClick?: () => void;
    onNextClick?: () => void;
    onSetupClick?: () => void;
    setupButtonHref: string;
    showContinueButton: boolean;
    isLoading: boolean;
};

const ReturnGuardNavigationControls: React.FC<IReturnGuardNavigationControlsType> = ({
    onBackClick,
    onSetupLaterClick,
    onNextClick,
    onSetupClick,
    setupButtonHref,
    showContinueButton,
    isLoading
}: IReturnGuardNavigationControlsType) => {
    const scope = "dashboard-onboarding"; 
    const { getTranslation } = useDashboardTranslation();

    return (
        <div className="onboarding-wizard-return-guard-nav-buttons">
            <div className="onboarding-wizard-nav-buttons-back">
                {onBackClick &&
                    <Button
                        text={getTranslation('BACK', scope)}
                        variant={BUTTON_VARIANTS.Transparent}
                        disabled={false}
                        onClick={onBackClick}
                        />
                }
            </div>
            <div className="onboarding-wizard-nav-buttons-continue-with-link">
                <div className="onboarding-wizard-nav-buttons-next-group">
                    <div className="onboarding-wizard-nav-buttons-skip">
                        {onSetupLaterClick &&
                            <Button
                                text={getTranslation('SET_UP_LATER', scope)}
                                variant={BUTTON_VARIANTS.Secondary}
                                disabled={false}
                                hasLoader={true}
                                isLoading={isLoading}
                                onClick={onSetupLaterClick}
                                />
                        }
                    </div>
                
                    {showContinueButton ? (
                        onNextClick && (
                            <div className="onboarding-wizard-nav-buttons-continue">
                                <Button
                                    text={getTranslation('CONTINUE_ONBOARDING', scope)}
                                    variant={BUTTON_VARIANTS.PrimaryAccent}
                                    disabled={false}
                                    onClick={onNextClick}
                                    hasLoader={true}
                                    isLoading={isLoading}
                                />
                            </div>
                        )
                    ) : (
                        onSetupClick && (
                            <div className="onboarding-wizard-nav-buttons-continue" onClick={onSetupClick}>
                                <ButtonLink
                                    text={getTranslation('SET_UP_NOW', scope)}
                                    variant={BUTTON_VARIANTS.PrimaryAccent}
                                    href={setupButtonHref}
                                    target="_blank"
                                    disabled={false}
                                />
                            </div>
                        )
                    )}
                </div>

                <div className="onboarding-wizard-nav-buttons-support-link" onClick={() => onboardingNavigationStore.openSupportChat()}>
                    <FontBody1 color={FONT_COLOR.PRIMARY2}>{getTranslation('NEED_HELP', scope)}</FontBody1>
                    <FontBody1 color={FONT_COLOR.PRIMARY2} variant={FONT_VARIANT.UNDER_LINE}>{getTranslation('TALK_TO_SUPPORT', scope)}</FontBody1>
                </div>
            </div>
        </div>
    );
}

export default ReturnGuardNavigationControls;